import { useParams } from 'react-router-dom';
import { useAuth } from '@/features/auth/use-auth';
import { AdminAsambleaPanel } from '@/features/asambleas/admin-panel';
import { ComiteAsambleaPanel } from '@/features/asambleas/comite-panel';
import { PropietarioAsambleaPanel } from '@/features/asambleas/propietario-panel';

/**
 * Dispatcher by rol — renders different panel based on session role.
 * See CLAUDE.md: "Role dispatch en route entry".
 */
export function AsambleaDetailRoute() {
  // condoId from URL — always present inside TenantShell (/app/condominios/:condoId/*)
  const { asambleaId, condoId } = useParams<{ asambleaId: string; condoId?: string }>();
  const { session } = useAuth();

  if (!asambleaId) return null;

  const effectiveRol = session
    ? session.isSuperAdmin
      ? 'admin'
      : condoId
        ? session.tenants[condoId]
        : undefined
    : undefined;

  switch (effectiveRol) {
    case 'admin':
    case 'super_admin':
      return <AdminAsambleaPanel asambleaId={asambleaId} />;
    case 'comite':
      return <ComiteAsambleaPanel asambleaId={asambleaId} />;
    case 'propietario':
    case 'residente':
      return <PropietarioAsambleaPanel asambleaId={asambleaId} />;
    default:
      return <ComiteAsambleaPanel asambleaId={asambleaId} />;
  }
}
